enum FundBusinessSectorType {
  ENERGI = 'Energi',
  VRIGEBRANSJEFOND = 'Øvrige_Bransjefond',
  HELSEVERN = 'Helsevern',
  FINANSIELLETJENESTER = 'Finansielle_Tjenester',
  INFORMASJONSTEKNOLOGI = 'Informasjonsteknologi',
  TELEKOMMUNIKASJON = 'Telekommunikasjon',
  FORBRUKSVARER = 'Forbruksvarer',
  INDUSTRI = 'Industri',
  MATERIALER = 'Materialer',
  FORSYNING = 'Forsyning',
  UDEFINERT = 'Udefinert',
}

export default FundBusinessSectorType;
